import { RootState } from '../store';

export const selectFont = (state: RootState) => state.font.font;
